/* Sophie Tea — Falling Petal Cursor
   Drop-in for Shopify. Requires a <canvas id="st-petals"> on the page.
   Recommended layout/theme.liquid placement:
     <canvas id="st-petals" style="position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:9999;"></canvas>
     <script src="{{ 'petal-cursor.js' | asset_url }}" defer></script>
*/
(() => {
  const cv = document.getElementById('st-petals');
  if (!cv) return;
  const ctx = cv.getContext('2d');
  let W = 0, H = 0, DPR = window.devicePixelRatio || 1;

  function resize() {
    W = window.innerWidth; H = window.innerHeight;
    cv.width = W * DPR; cv.height = H * DPR;
    cv.style.width = W + 'px'; cv.style.height = H + 'px';
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }
  window.addEventListener('resize', resize);
  resize();

  // Palette pulled from the left canvas in the studio paintings —
  // soft creams, blush, dusty pinks, peach, faded coral.
  const PETAL_COLORS = [
    { base: '#F8E1E5', edge: '#EFC4CB', tip: '#FCEFF1' },
    { base: '#EFC4CB', edge: '#D89AA4', tip: '#F8E1E5' },
    { base: '#FBF0E4', edge: '#F2DDC7', tip: '#FFFAF2' },
    { base: '#F4D8DD', edge: '#E8B5BD', tip: '#FCEFF1' },
    { base: '#F2C9B9', edge: '#E2A893', tip: '#F9E3D5' },
    { base: '#FAE9DA', edge: '#E8CFB7', tip: '#FFF6EA' },
    { base: '#E8B5BD', edge: '#C8929B', tip: '#F4D8DD' },
  ];

  const rand = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

  const petals = [];
  let mouse = { x: -999, y: -999, lastDrop: 0, prevX: 0, prevY: 0, vx: 0, vy: 0 };

  function spawnPetal(x, y) {
    const c = pick(PETAL_COLORS);
    const size = rand(8, 22);
    petals.push({
      x: x + rand(-6, 6),
      y: y + rand(-4, 4),
      vx: rand(-0.2, 0.2) + mouse.vx * 0.04,
      vy: rand(0.05, 0.25),
      gravity: rand(0.0035, 0.008),
      drag: 0.992,
      swayFreq: rand(0.0008, 0.0018),
      swayPhase: rand(0, Math.PI * 2),
      swayAmp: rand(0.25, 0.65),
      rot: rand(0, Math.PI * 2),
      rotSpeed: rand(-0.0012, 0.0012),
      size,
      ratio: rand(0.36, 0.52),
      curl: rand(0.08, 0.22),
      colors: c,
      bornAt: performance.now(),
      maxLife: rand(7000, 11000),
      alpha: rand(0.78, 0.95),
    });
    if (petals.length > 220) petals.splice(0, petals.length - 220);
  }

  window.addEventListener('mousemove', (e) => {
    mouse.prevX = mouse.x; mouse.prevY = mouse.y;
    mouse.x = e.clientX; mouse.y = e.clientY;
    if (mouse.prevX > -100) {
      mouse.vx = mouse.x - mouse.prevX;
      mouse.vy = mouse.y - mouse.prevY;
    }
    const speed = Math.hypot(mouse.vx, mouse.vy);
    const now = performance.now();
    const interval = speed > 6 ? 90 : (speed > 2 ? 150 : 280);
    if (now - mouse.lastDrop > interval) {
      const n = speed > 8 ? 2 : 1;
      for (let i = 0; i < n; i++) {
        spawnPetal(mouse.x + rand(-10, 10), mouse.y + rand(-6, 6));
      }
      mouse.lastDrop = now;
    }
  });

  function drawPetal(p, t) {
    const age = t - p.bornAt;
    const k = age / p.maxLife;
    if (k >= 1) return false;

    p.vy = (p.vy + p.gravity) * p.drag;
    p.vx *= p.drag;
    const sway = Math.sin(t * p.swayFreq + p.swayPhase) * p.swayAmp;
    p.x += p.vx + sway * 0.4;
    p.y += p.vy;
    p.rot += p.rotSpeed + sway * 0.0006;

    if (p.y > H + 40 || p.x < -40 || p.x > W + 40) return false;

    const enter = Math.min(1, age / 380);
    const easeIn = 1 - Math.pow(1 - enter, 2);
    const fadeOut = k > 0.78 ? 1 - (k - 0.78) / 0.22 : 1;
    const alpha = p.alpha * easeIn * fadeOut;
    if (alpha < 0.02) return true;

    const len = p.size;
    const wid = len * p.ratio;
    const c = p.colors;
    const tipY = -len * 0.55, baseY = len * 0.55;
    const curlX = wid * p.curl;

    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.rot + sway * 0.3);
    ctx.globalAlpha = alpha;

    ctx.save();
    ctx.translate(0.6, 1.2);
    ctx.fillStyle = 'rgba(60, 35, 35, 0.10)';
    ctx.beginPath();
    ctx.ellipse(0, 0, wid * 0.55, len * 0.55, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    const g = ctx.createLinearGradient(0, baseY, 0, tipY);
    g.addColorStop(0, c.edge);
    g.addColorStop(0.45, c.base);
    g.addColorStop(1, c.tip);
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(0, baseY);
    ctx.bezierCurveTo(wid*0.55, baseY*0.55, wid*0.45+curlX, tipY*0.55, curlX*0.6, tipY);
    ctx.bezierCurveTo(-wid*0.45+curlX, tipY*0.55, -wid*0.55, baseY*0.55, 0, baseY);
    ctx.closePath();
    ctx.fill();

    ctx.strokeStyle = `rgba(255, 255, 255, ${0.15 * alpha})`;
    ctx.lineWidth = 0.6;
    ctx.beginPath();
    ctx.moveTo(0, baseY * 0.7);
    ctx.lineTo(curlX * 0.4, tipY * 0.85);
    ctx.stroke();

    ctx.strokeStyle = `rgba(140, 90, 95, ${0.10 * alpha})`;
    ctx.lineWidth = 0.7;
    ctx.beginPath();
    ctx.moveTo(0, baseY * 0.95);
    ctx.bezierCurveTo(wid*0.55, baseY*0.55, wid*0.45+curlX, tipY*0.55, curlX*0.6, tipY*0.98);
    ctx.stroke();

    ctx.restore();
    return true;
  }

  function tick(t) {
    ctx.clearRect(0, 0, W, H);
    for (let i = petals.length - 1; i >= 0; i--) {
      if (!drawPetal(petals[i], t)) petals.splice(i, 1);
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
